import React from 'react'
import PropTypes from 'prop-types'
import './planos.scss'

// Components
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Typeform as Form } from '../components/Contato/forms'

const ContactPage = (props, context) =>
<div>
  <Header name="home-header site-header" style={{paddingBottom: '0'}}>
    <div className="container">
      <div className="grid-center">
         <div className="col-6_md-10 grid-column content center">
            <h1 style={{ textAlign: 'center', width: '100%'}}>
              {context.t('Será um prazer falar com você')}
            </h1>
            <p style={{marginBottom: '50px'}}>
              {context.t('Deixe seus dados abaixo e nossa equipe irá entrar em contato com você para iniciar a conversa. Queremos muito poder ouvir e ajudar você.')}
            </p>
         </div>
      </div>
    </div>
  </Header>

  <Form />

  <Footer/>

</div>

ContactPage.contextTypes = {
  t: PropTypes.func.isRequired
}

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contato.js